import React from "react";
// consts
import CYLINDER_STATE from "shared/consts/cylinder";
// icons
import CylinderIcon from 'app/ui/pages/monitor/monitorTableBody/monitorTableRow/cylinderIcons/cylinderIcon/CylinderIcon';
// utils
import _ from "lodash";
// css
import styles from "./CylinderGroup.module.scss";

const CylinderGroup = ({
  ghostCylinders,
  commonCylinders,
  cylinderSize,
}) => {
  const groupByGhostStatus = (array) =>
    array.reduce((acc, item) => {
      const state = item.ghostState;
      if (_.isNil(acc[state])) acc[state] = [];
      acc[state].push(item);
      return acc;
    }, {});

  const groupByStatus = (array) =>
    array.reduce((acc, item) => {
      const state = item.state;
      if (_.isNil(acc[state])) acc[state] = [];
      acc[state].push(item);
      return acc;
    }, {});

  const groupedGhost = groupByGhostStatus(ghostCylinders || []);
  const groupedCommon = groupByStatus(commonCylinders || []);

  const {
    REQUESTED,
    PENDING,
    FULL,
    CURRENT: CURRENT_COMMON,
    EMPTY: EMPTY_COMMON,
  } = CYLINDER_STATE.CYLINDER_STATE;

  const {
    CURRENT: CURRENT_GHOST,
    EMPTY: EMPTY_GHOST,
    FINISHED,
  } = CYLINDER_STATE.GHOST_CYLINDER_STATE;

  const STATE_DESCRIPTION = {
    [REQUESTED]: "Solicitado",
    [PENDING]: "Pendente",
    [FULL]: "Cheio",
    [CURRENT_COMMON]: "Atual",
    [EMPTY_COMMON]: "Vazio",
  };

  const STATE_GHOST_DESCRIPTION = {
    [CURRENT_GHOST]: "Atual Pendente",
    [EMPTY_GHOST]: "vazio Pendente",
  };

  const renderGroupedList = (
    grouped,
    stateOrder,
    descriptionMap,
    cylinderMode
  ) =>
    stateOrder
      .filter((state) => grouped[state] && grouped[state].length > 0)
      .map((state, index) => {
        const cylinders = grouped[state];
        const firstCylinder = cylinders[0];
        return (
          <React.Fragment key={`${state}-${index}`}>
            <div className={styles.content}>
              <div className={styles.pressure}>
                <CylinderIcon
                  state={firstCylinder.state}
                  pressure={firstCylinder.pressure}
                  cylinderSize={cylinderSize}
                  ghostState={firstCylinder.ghostState}
                  cylinderMode={cylinderMode}
                />
              </div>
              <span className={styles.itemText}>
                {`${cylinders.length} - Cilindro(s) ${descriptionMap[state]}(s)`}
              </span>
            </div>
          </React.Fragment>
        );
      });

  return (
    <>
      {renderGroupedList(
        groupedGhost,
        [CURRENT_GHOST, EMPTY_GHOST, FINISHED],
        STATE_GHOST_DESCRIPTION,
        "ghost"
      )}
      {renderGroupedList(
        groupedCommon,
        [REQUESTED, PENDING, FULL, CURRENT_COMMON, EMPTY_COMMON],
        STATE_DESCRIPTION,
        "common"
      )}
    </>
  );
};

export default CylinderGroup;
